import type {
  GetLotteryTemplateResponse,
  GetLotteryTemplatesParams,
} from '@lotta/shared/types-lottery-api';
import { apis } from './apis';

const lotteryTemplateApis = apis.injectEndpoints({
  endpoints: (build) => ({
    getLotteryTemplates: build.query<
      GetLotteryTemplateResponse,
      GetLotteryTemplatesParams['retailUnit']
    >({
      query: (retailUnit: string) => `/${retailUnit}/lottery-template`,
    }),
  }),
});

export const { useGetLotteryTemplatesQuery } = lotteryTemplateApis;
